<template>
    <div :class="['move-group', 'move-group--'+status]">
        <div class="move-group__title">{{ group.label }}</div>
        <div class="move-group__body">
            <move-model v-for="(model) in group.models" :key="model.id" :model="model" :options="options">
            </move-model>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        "group": {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        status() {
            if (this.group.models.every(model => {
                return model.status == 'success';
            })) {
                return 'success';
            }
            if (this.group.models.some(model => {
                return model.status == 'danger';
            })) {
                return 'danger';
            }
            return 'warning';
        },
        options() {
            let optionsObject = {
                display_level: 'all',
                display_status: [],
            };
            if (this.group.options) {
                if (this.group.options.display_level) {
                    optionsObject.display_level = this.group.options.display_level;
                }
                if (this.group.options.display_status) {
                    optionsObject.display_status = this.group.options.display_status;
                }
            }
            return optionsObject;
        }
    },
    watch: {
        status() {
            this.group.status = this.status;
        }
    },

    methods: {
    },

    mounted() {
        this.group.status = this.status;
    },
}
</script>
